import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/



/******************************
*******  Asynchronous  ********
******************************/

export function callLogin(loginData) {
	return dispatch => {
		let url = api.URL + endpoint.USERS_LOGIN;
		return fetch(url, {
		  method: 'post',
		  headers: api.HEADERS,
		  body: JSON.stringify(loginData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


// WEBPACK FOOTER //
// ./src/actions/login.jsx